import { fontTypeIconAlignmentMixin } from './fontTypeIconAlignmentMixin';
import { fontTypeMixin } from './fontTypeMixin';
import { mediaQueryMixin } from './mediaQueryMixin';

/** @mixin fontTypeMediaQueryMixin */
/**
 * @method
 */
export var fontTypeMediaQueryMixin = mediaQueryMixin(function (mediaProps) {
  if (!('fontType' in mediaProps)) {
    return '';
  }
  return function (props) {
    return [fontTypeMixin(Object.assign({}, props, mediaProps)), fontTypeIconAlignmentMixin(Object.assign({}, props, mediaProps))];
  };
});